/**
 * AddCatchupCtrl controller
 * Add/Edit CatchUp TV Channels
 */

import { DRM_ACCOUNT_TYPES, STREAMING_PROVIDER_TYPES, URL_PATTERN_FOR_TEMPLATES } from 'app/core/constants'
import { TypeaheadClass } from '../../app/helpers/typeahead'

/**
 * AddCatchupCtrl controller
 *
 * @class AddCatchupCtrl
 * @memberof mwApp/catchups
 * @see mwApp/catchups
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/catchups.controller:AddCatchupCtrl
 */
/* @ngInject */
export default function AddCatchupCtrl (
  $uibModalInstance,
  Catchup,
  TemplateVariable,
  chnl,
  cu
) {
  var vm = this

  vm.urlPattern = URL_PATTERN_FOR_TEMPLATES

  /**
   * Catchup
   *
   * @memberof mwApp/catchups.controller:AddCatchupCtrl
   * @type {models.Catchup}
   */
  vm.cu = cu

  /**
   * DRM profiles
   *
   * @memberOf mwApp/catchups.controller:AddCatchupCtrl
   * @type {String[]}
   */
  vm.drmProfiles = []

  /**
   * DRM account types
   *
   * @memberOf mwApp/catchups.controller:AddCatchupCtrl
   * @type {Object}
   */
  vm.drm_account_types = DRM_ACCOUNT_TYPES

  /**
   * Channel
   *
   * @memberof mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   * @type {models.Channel|null}
   */
  vm.chnl = chnl

  /**
   * Streaming Provider types
   *
   * @memberof mwApp/catchups.controller:AddCatchupCtrl
   * @type {Object}
   */
  vm.streaming_provider_types = STREAMING_PROVIDER_TYPES

  /**
   * isNew flag
   *
   * @memberof mwApp/catchups.controller:AddCatchupCtrl
   * @type {Boolean}
   */
  vm.isNew = cu._isNew()

  /**
   * Set default channel
   */
  if (chnl) {
    vm.cu.channel = chnl
  }

  // load channels from extra
  var channels = vm.channels = []
  if (!chnl) {
    Catchup.loadExtra(Catchup.extraFor(cu))
      .then(extra => {
        channels = extra.channels
        vm.drmProfiles = extra.drmProfiles
          .map(({ id, name, enabled, providerType, drmType }) => ({ id, name, enabled, providerType, drmType }))
        vm.playbackTokenGenerators = extra.playbackTokenGenerators
      })
  }

  /**
   * Filter channels, it seems that this works faster, then filter in ui-select-choices
   *
   * @param  {String} search
   */
  vm.refreshChannels = function (search) {
    search = search ? search.toLowerCase() : null
    vm.channels = search
      ? channels.filter(c => c.name && c.name.toLowerCase().indexOf(search) >= 0)
      : null
  }

  /**
   * Create or edit catchup, and close modal window afterwards
   *
   * @memberof mwApp/catchups.controller:AddCatchupCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    cu.name = cu.name || cu.channel.name
    if (vm.cu.mediaUrl && !vm.cu.mediaUrl.$extchecked) {
      vm.cu.mediaUrl.playbackTokenGeneratorId = null
    }
    cu._save()
      .then(
        () => {
          // reload catchup after create/update
          cu._update()
            .finally(
              () => {
                $uibModalInstance.close(cu)
                vm.unsetDisable()
              }
            )
        }
      ).finally(vm.unsetDisable)
  }

  /**
   * Change drm profile callback function
   * @returns {Function}
   */
  vm.changeDrmProfile = () => {
    if (!vm.cu.mediaUrl.drmProfiles.length) {
      vm.cu.mediaUrl.kek = null
    }
  }

  /**
   * Disable not enable items
   * @param item
   * @returns {boolean}
   */
  vm.disableChoice = (item) => {
    return !item.enabled
  }

  /**
   * Filter for drm profiles
   * @returns {Function}
   */
  vm.filterProfiles = function () {
    return function (profile) {
      if (!vm.cu.mediaUrl ||
        !vm.cu.mediaUrl.drmProfiles ||
        !vm.cu.mediaUrl.drmProfiles.length) {
        return true
      }

      const selectedProviderType = vm.findSelectedProviderType()
      return profile.providerType === selectedProviderType && !vm.cu.mediaUrl.drmProfiles.find((p) => p.drmType === profile.drmType)
    }
  }

  /**
   * Find provider type by platformName from selected profiles
   * @returns {Function}
   */
  vm.findSelectedProviderType = () => {
    const selectedProfile = vm.cu.mediaUrl && vm.cu.mediaUrl.drmProfiles && vm.cu.mediaUrl.drmProfiles.length && vm.cu.mediaUrl.drmProfiles[0]
    if (!selectedProfile) {
      return true
    }

    return selectedProfile.providerType
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/catchups.controller:AddCatchupCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  TemplateVariable.loadAllVariables()
    .to(vm.templateVariables = [])
    .then(() => {
      const setUrlValue = function (val) {
        vm.cu.mediaUrl.mediaUrl = val
      }

      vm.typeaheadUrl = new TypeaheadClass(vm.templateVariables, setUrlValue)
    })
}
